// Billing helpers shared across the client portal. The backend already returns a
// `billable` block on each project ({ hours, amount, currency }); these wrap it
// with a safe fallback and currency formatting.

export function projectTotal(p) {
  if (p && p.billable && p.billable.amount != null) return p.billable.amount
  if (!p || !p.pricing_type || p.pricing_type === 'none') return null
  const hours = p.billable ? (p.billable.hours || 0) : 0
  if (p.pricing_type === 'fixed')  return p.price_amount ?? null
  if (p.pricing_type === 'hourly') return Math.round(hours * (p.price_amount || 0) * 100) / 100
  return null
}

export function projectHours(p) {
  return p && p.billable ? (p.billable.hours || 0) : 0
}

const SYMBOLS = { ILS: '₪', USD: '$', EUR: '€', GBP: '£' }

export function fmtMoney(amount, currency = 'ILS') {
  if (amount == null) return '—'
  const sym = SYMBOLS[currency] || (currency + ' ')
  return sym + Number(amount).toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export function fmtHours(seconds) {
  return (Math.round(((seconds || 0) / 3600) * 100) / 100) + 'h'
}
